import { memo } from "react";

const ActionEdit = () => (
  <svg viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66619 7.01321C6.5815 7.01321 6.51284 7.08187 6.51284 7.16656V33.8332C6.51284 33.9179 6.58148 33.9866 6.66619 33.9866H33.3329C33.4176 33.9866 33.4862 33.9179 33.4862 33.8332V22.1666C33.4862 21.3308 34.1637 20.6532 34.9995 20.6532C35.8353 20.6532 36.5128 21.3308 36.5128 22.1666V33.8332C36.5128 35.5895 35.0891 37.0132 33.3329 37.0132H6.66619C4.90995 37.0132 3.48621 35.5895 3.48621 33.8332V7.16656C3.48621 5.4103 4.90993 3.98657 6.66619 3.98657H18.3329C19.1686 3.98657 19.8462 4.66411 19.8462 5.49989C19.8462 6.33567 19.1686 7.01321 18.3329 7.01321H6.66619Z"
      fill="#141516"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.9126 3.98657C29.3142 3.9865 29.6993 4.14603 29.9832 4.43005L36.0706 10.5201C36.6613 11.1111 36.6613 12.0689 36.0707 12.6598L18.835 29.9031C18.5512 30.187 18.1661 30.3465 17.7647 30.3465H11.667C10.8312 30.3465 10.1537 29.669 10.1537 28.8332V22.7665C10.1537 22.3654 10.3129 21.9808 10.5963 21.697L27.8422 4.43045C28.126 4.14633 28.5111 3.98665 28.9126 3.98657ZM28.9133 7.64092L13.1803 23.3928V27.3199H17.1376L32.8607 11.59L28.9133 7.64092Z"
      fill="#141516"
    />
  </svg>
);

export default memo(ActionEdit);
